import React, { Component } from 'react';
import styled from 'styled-components';
import sectionBorderRadius from './sectionBorderRadius';

const Wrapper = styled.div`
  color: ${props => props.theme.botCardMessageTextColor};
  background-color: ${props => props.theme.botCardMessageBackgroundColor};

  line-height: 19px;
  padding: 12px 18px;

  ${sectionBorderRadius};
  ${({ flexGrow }) => flexGrow && 'flex-grow: 1'};
`;

export const TitleText = styled.div`
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.3px;
`;

export const SubTitleText = styled.div`
  font-size: 12px;
  letter-spacing: 0.26px;
  ${({ subtitleStyles }) => subtitleStyles};
`;

const makeBulletedList = (text, listIndex) => {
  const listItems = text.map((token, itemIndex) => <li key={itemIndex}>{token}</li>);
  return <ul key={listIndex}>{listItems}</ul>;
};
const splitStringsFromLists = text => {
  const trimmedText = text ? text.split('\n\n') : null;
  const transformedText = trimmedText.map((a, listIndex) => {
    const [leadingText, ...splitText] = a.split('- ');
    return (
      <div key={listIndex}>
        <span>{leadingText}</span>
        {makeBulletedList(splitText, listIndex)}
      </div>
    );
  });
  return transformedText;
};

export const CardText = ({ text }) => {
  const transformedText = text.includes('- ') ? splitStringsFromLists(text) : text;

  return <div>{transformedText}</div>;
};

class Title extends Component {
  render() {
    const {
      title,
      subtitle,
      text,
      isStart,
      isEnd,
      flexGrow = false,
      subtitleStyles = {}
    } = this.props;

    return (
      <Wrapper isStart={isStart} isEnd={isEnd} data-test-type="botTitle" flexGrow={flexGrow}>
        {title && <TitleText>{title}</TitleText>}
        {subtitle && <SubTitleText subtitleStyles={subtitleStyles}>{subtitle}</SubTitleText>}
        {text && <CardText text={text} />}
      </Wrapper>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Title.js